<template>
    <div>
        <h2 class="mb-1">Peer Session Report</h2>
        
        <div style="display: flex; flex-wrap: wrap; align-items: center;" class="mb-2">
            <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="btn-icon mr-50"
                style="height: 37px; margin-top: 12px;"
                @click.stop.prevent="prevRange()"
            >
                <feather-icon icon="ChevronLeftIcon" />
            </b-button>

            <b-form-group
                label="Start Date"
                class="mr-50 w-10"
            >
                <date-picker v-model="startDate" type="month" format="MM-DD-YYYY" value-type="DD/MM/YYYY" v-if="selectedRangeDate === 'month' || selectedRangeDate === 'quarter'"></date-picker>
                <date-picker v-model="startDate" type="year" format="MM-DD-YYYY" value-type="DD/MM/YYYY" v-else-if="selectedRangeDate === 'year'"></date-picker>
                <date-picker v-model="startDate" type="date" format="MM-DD-YYYY" value-type="DD/MM/YYYY" v-else-if="!selectedRangeDate || selectedRangeDate === 'custom'"></date-picker>
            </b-form-group>
        
            <b-form-group
                label="End Date"
                class="mr-50"
            >
                <date-picker v-model="endDate" type="date" format="MM-DD-YYYY" value-type="DD/MM/YYYY" :disabled="selectedRangeDate === 'month' || selectedRangeDate === 'quarter' || selectedRangeDate === 'year' ? true : false"></date-picker>
            </b-form-group>

            <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="btn-icon ml-0"
                style="height: 37px; margin-top: 12px;"
                @click.stop.prevent="nextRange()"
            >
                <feather-icon icon="ChevronRightIcon" />
            </b-button>
            
            <div :class="!selectedRangeDate ? 'pl-1' : 'pl-1'">
                <b-form-group>
                    <b-form-radio-group
                        v-model="selectedRangeDate"
                        button-variant="outline-primary range-date"
                        buttons
                        class="p-0 mr-2"
                    >
                        <b-form-radio style="height: 37px; padding: 11px;" v-for="(option,index) in optionsRangeDate" :key="index + makeid(6)" :value="option.value">{{option.text}}</b-form-radio>
                        <b-form-radio style="height: 37px; padding: 10px;" v-if="selectedRangeDate" value="x">x</b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
            </div>
            
            <b-form-group label="Duration">
                <v-select
                    v-model="filterDuration"
                    placeholder="Duration"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="psfDurationOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Service Delivery">
                <v-select
                    v-model="filterServiceDelivery"
                    placeholder="Service Delivery"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="psfServiceDeliveryOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Remote Type">
                <v-select
                    v-model="filterRemoteType"
                    placeholder="Remote Type"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="psfRemoteTypeOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Service Type">
                <v-select
                    v-model="filterServiceType"
                    placeholder="Service Type"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="psfServiceTypeOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <b-form-group label="Further Actions">
                <v-select
                    v-model="filterFurtherActions"
                    placeholder="Further Actions"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="psfFurtherActionsOptions"
                    style="background: #fff; min-width: 200px;"
                    class="mr-2"
                />
            </b-form-group>

            <div>
                <b-button
                    v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                    variant="flat-primary"
                    class="mb-1 mt-2 p-75"
                    @click="resetFilters"
                >
                    <feather-icon
                        icon="XIcon"
                        class="mr-50"
                    />
                    <span class="align-middle">Reset filters</span>
                </b-button>
            </div>
        </div>

        <b-card>
            <h5>Peer Session Forms</h5>
            <hr>
            <b-row>
                <!-- Total Forms -->
                <b-col lg="3" md="3" sm="12">
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                            <div class="truncate">
                                <div class="text-primary" v-if="isBusy">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                                <h2 class="mb-25 font-weight-bolder" v-else>
                                    {{ totalSessionForms }}
                                </h2>
                                <span>Total Session Forms</span>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <!-- Duration -->
                <b-col lg="3" md="3" sm="12" v-for="(item, index) in psfDurationOptions" :key="'duration-' + index">
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                            <div class="truncate">
                                <div class="text-primary" v-if="isBusy">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                                <h2 class="mb-25 font-weight-bolder" v-else>
                                    {{ getCounter(item, 'Duration') }}
                                </h2>
                                <span>Duration / {{ item }}</span>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <!-- Service Delivery -->
                <b-col lg="3" md="3" sm="12" v-for="(item, index) in psfServiceDeliveryOptions" :key="'service-delivery-' + index">
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                            <div class="truncate">
                                <div class="text-primary" v-if="isBusy">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                                <h2 class="mb-25 font-weight-bolder" v-else>
                                    {{ getCounter(item, 'Service Delivery') }}
                                </h2>
                                <span>Service Delivery / {{ item }}</span>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <!-- Remote Type -->
                <b-col lg="3" md="3" sm="12" v-for="(item, index) in psfRemoteTypeOptions" :key="'remote-type-' + index">
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                            <div class="truncate">
                                <div class="text-primary" v-if="isBusy">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                                <h2 class="mb-25 font-weight-bolder" v-else>
                                    {{ getCounter(item, 'Remote Type') }}
                                </h2>
                                <span>Remote Type / {{ item }}</span>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <!-- Service Type -->
                <b-col lg="3" md="3" sm="12" v-for="(item, index) in psfServiceTypeOptions" :key="'service-type-' + index">
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                            <div class="truncate">
                                <div class="text-primary" v-if="isBusy">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                                <h2 class="mb-25 font-weight-bolder" v-else>
                                    {{ getCounter(item, 'Service Type') }}
                                </h2>
                                <span>Service Type / {{ item }}</span>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>

                <!-- Further Actions -->
                <b-col lg="3" md="3" sm="12" v-for="(item, index) in psfFurtherActionsOptions" :key="'further-actions-' + index">
                    <b-card no-body style="border: 1px solid #ecebed;">
                        <b-card-body class="d-flex justify-content-between align-items-center">
                            <div class="truncate">
                                <div class="text-primary" v-if="isBusy">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                                <h2 class="mb-25 font-weight-bolder" v-else>
                                    {{ getCounter(item, 'Further Actions') }}
                                </h2>
                                <span>Further Actions / {{ item }}</span>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>
            </b-row>
        </b-card>

        <download-csv 
            :data="jsonData"
            class="mb-1 btn btn-default"
            name="peer-session-report.csv"
            :style="readyToExport ? 'background: #94221e; color: #fff; cursor: pointer; opacity: 1;' : 'background: #94221e; color: #fff; cursor: no-drop; opacity: 0.5;'"
            delimiter=","
            v-if="isDataSpecialist"
        >
            CSV Export
            <b-spinner small v-if="!readyToExport" />
        </download-csv>
    </div>
</template>

<script>
import { 
    BButton, BRow, BCol, BFormGroup, BCard, BCardBody, BSpinner, BFormRadioGroup, BFormRadio
} from 'bootstrap-vue'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import moment from 'moment'
import { db, auth } from '@/firebase'

export default {
    data() {
        return {
            // Date filters
            startDate: null,
            endDate: null,
            selectedRangeDate: 'month',
            optionsRangeDate: [
                { text: 'Month', value: 'month' },
                { text: 'Quarter', value: 'quarter' },
                { text: 'Year', value: 'year' },
                { text: 'Custom', value: 'custom' },
            ],
            rangeDinamic: false,
            
            // Filters
            filterDuration: '',
            filterServiceDelivery: '',
            filterRemoteType: '',
            filterServiceType: '',
            filterFurtherActions: '',

            // Data
            totalSessionForms: 0,
            arrayResults: [],
            filteredData: [],
            jsonData: [],
            
            // Loading states
            isBusy: true,
            isDataSpecialist: false,
            readyToExport: false,

            // Options
            psfDurationOptions: [
                '15 minutes',
                '30 minutes',
                '45 minutes',
                '60 minutes',
                '75 minutes',
                '90 minutes'
            ],
            psfServiceDeliveryOptions: ['Remote'],
            psfRemoteTypeOptions: ['Video', 'Phone'],
            psfServiceTypeOptions: [
                'Facilitating access to care',
                'Recovery planning',
                'Modeling coping skills',
                'Mentoring and goal setting',
                'Non-clinical crisis support',
                'Identifying strengths',
                'Relationship building',
                'Promoting self-advocacy',
                'Education around various modes of recovery',
                'Travel training',
                'Linkage to formal recovery supports',
                'Psychoeducation'
            ],
            psfProblemStatusOptions: [
                'Solutions Achieved',
                'Solutions Partially Achieved',
                'Solutions Not Achieved',
                'On Hold (lower priority)',
                'Solutions Not Feasible as part of Peer Services'
            ],
            psfGoalStatusOptions: [
                'Worked On',
                'Did Not Work On',
                'On Hold',
                'Completed',
                'Not Met'
            ],
            psfFurtherActionsOptions: [
                'Continue Peer Services',
                'Service at this level no longer necessary',
                'Client ended services',
                'Referral to treatment services',
                'Referral to recovery services'
            ],
            psfTreatmentReferralOptions: [
                'Inpatient Rehabilitation',
                'Residential',
                'Outpatient'
            ],
            psfRecoveryReferralOptions: [
                'Recovery Community and Outreach Center',
                'Youth Clubhouse',
                'Peer Advocate',
                'Open Access Center',
                'Family Navigator',
                'Regional Addiction Resource Center',
                'Self Help',
                'Other'
            ],
            psfRecoverySelfHelpOptions: [
                'GA',
                'Smart Recovery',
                'Other'
            ]
        }
    },
    components: {
        BButton, BRow, BCol, BFormGroup, BCard, BCardBody, BSpinner, BFormRadioGroup, BFormRadio,
        DatePicker, vSelect
    },
    directives: {
        Ripple,
    },
    watch: {
        selectedRangeDate(val) {
            this.functionDateRange(val)
        },
        startDate(val) {
            if(val) {
                this.isBusy = true
                this.functionDateRange(this.selectedRangeDate)
                this.rangeDinamic ? this.rangeDinamic = false : ''
                this.applyFilters()
            }
        },
        endDate(val) {
            if(val) {
                this.isBusy = true
                this.applyFilters()
            }
        },
        filterDuration() { this.applyFilters() },
        filterServiceDelivery() { this.applyFilters() },
        filterRemoteType() { this.applyFilters() },
        filterServiceType() { this.applyFilters() },
        filterFurtherActions() { this.applyFilters() }
    },
    methods: {
        makeid(length) {
            var result = '';
            var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for(var i = 0; i < length; i++) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return result;
        },
        getCounter(payload, type) {
            var filterResult = this.arrayResults.filter(ele => ele.text === payload && ele.type === type)
            if(filterResult.length) {
                return filterResult[0].count
            } else {
                return 0
            }
        },
        resetFilters() {
            this.startDate = null
            this.endDate = null
            this.filterDuration = ''
            this.filterServiceDelivery = ''
            this.filterRemoteType = ''
            this.filterServiceType = ''
            this.filterFurtherActions = ''
        },
        functionDateRange(val) {
            if(val === 'month') {
                if(this.startDate) {
                    var formatDate1 = moment(this.startDate,'DD/MM/YYYY').format('MM/DD/YYYY')
                    var formatDate = moment(this.startDate,'DD/MM/YYYY').format('DD/MM/YYYY')
                    var expiredDate = moment(formatDate1).add(1, 'months').subtract(1, 'day')
                    var dateUpdateFormat = moment(expiredDate,'MM/DD/YYYY').format('DD/MM/YYYY')
                    this.startDate = formatDate
                    this.endDate = dateUpdateFormat
                } else {
                    var formatDate1 = moment(Date.now()).format('MM/DD/YYYY')
                    var formatDate = moment(Date.now()).format('DD/MM/YYYY')
                    var expiredDate = moment(formatDate1).add(1, 'months').subtract(1, 'day')
                    var dateUpdateFormat = moment(expiredDate,'MM/DD/YYYY').format('DD/MM/YYYY')
                    this.startDate = formatDate
                    this.endDate = dateUpdateFormat
                }
            } else if(val === 'quarter') {
                if(this.startDate) {
                    var formatDate1 = moment(this.startDate,'DD/MM/YYYY').format('MM/DD/YYYY')
                    var formatDate = moment(this.startDate,'DD/MM/YYYY').format('DD/MM/YYYY')
                    var expiredDate = moment(formatDate1).add(3, 'months').subtract(1, 'day')
                    var dateUpdateFormat = moment(expiredDate,'MM/DD/YYYY').format('DD/MM/YYYY')
                    this.startDate = formatDate
                    this.endDate = dateUpdateFormat
                } else {
                    var formatDate1 = moment(Date.now()).format('MM/DD/YYYY')
                    var formatDate = moment(Date.now()).format('DD/MM/YYYY')
                    var expiredDate = moment(formatDate1).add(3, 'months').subtract(1, 'day')
                    var dateUpdateFormat = moment(expiredDate,'MM/DD/YYYY').format('DD/MM/YYYY')
                    this.startDate = formatDate
                    this.endDate = dateUpdateFormat
                }
            } else if(val === 'year') {
                if(this.startDate) {
                    var formatDateNew = moment(this.startDate,'DD/MM/YYYY').format('MM/DD/YYYY')
                    var getYear = moment(formatDateNew).format('YYYY')
                    var formatDate1 = moment('01/01/'+getYear).format('MM/DD/YYYY')
                    var formatDate = '01/01/'+getYear
                    var expiredDate = moment(formatDate1).add(12, 'months').subtract(1, 'day')
                    var dateUpdateFormat = moment(expiredDate,'MM/DD/YYYY').format('DD/MM/YYYY')
                    this.startDate = formatDate
                    this.endDate = dateUpdateFormat
                } else {
                    var getYear = moment(Date.now()).format('YYYY')
                    var formatDate1 = moment('01/01/'+getYear).format('MM/DD/YYYY')
                    var formatDate = moment('01/01/'+getYear).format('DD/MM/YYYY')
                    var expiredDate = moment(formatDate1).add(12, 'months').subtract(1, 'day')
                    var dateUpdateFormat = moment(expiredDate,'MM/DD/YYYY').format('DD/MM/YYYY')
                    this.startDate = formatDate
                    this.endDate = dateUpdateFormat
                }
            } else if(val === 'x') {
                this.selectedRangeDate = ''
                this.startDate = null
                this.endDate = null
            }
        },
        prevRange() {
            if(this.startDate && this.selectedRangeDate) {
                var formatDate = moment(this.startDate,'DD/MM/YYYY').format('MM/DD/YYYY')
                var subtractDate = moment(formatDate).subtract(1, 'months')
                var dateUpdateFormat = moment(subtractDate,'MM/DD/YYYY').format('DD/MM/YYYY')

                this.rangeDinamic = true
                this.startDate = dateUpdateFormat
                this.functionDateRange(this.selectedRangeDate)
            }
        },
        nextRange() {
            if(this.startDate && this.selectedRangeDate) {
                var formatDate = moment(this.startDate,'DD/MM/YYYY').format('MM/DD/YYYY')
                var subtractDate = moment(formatDate).add(1, 'months')
                var dateUpdateFormat = moment(subtractDate,'MM/DD/YYYY').format('DD/MM/YYYY')

                this.rangeDinamic = true
                this.startDate = dateUpdateFormat
                this.functionDateRange(this.selectedRangeDate)
            }
        },
        applyFilters() {
            this.isBusy = true
            
            // Reset counters
            this.arrayResults.forEach(ele => {
                ele.count = 0
            })

            let flattenedData = []
            this.filteredData.forEach(item => {
                if(item.psfItemsFormRepeater && Array.isArray(item.psfItemsFormRepeater)) {
                    flattenedData.push(...item.psfItemsFormRepeater)
                }
            })

            let filtered = [...flattenedData]

            // Date filter
            if(this.startDate && this.endDate) {
                filtered = filtered.filter(item => {
                    if(!item.psfDate) return false
                    const itemDate = moment(item.psfDate, 'MM-DD-YYYY')
                    const start = moment(this.startDate, 'DD/MM/YYYY')
                    const end = moment(this.endDate, 'DD/MM/YYYY')
                    return itemDate.isBetween(start, end, null, '[]')
                })
            }

            // Apply all filters
            if(this.filterDuration) {
                filtered = filtered.filter(item => item.psfDuration === this.filterDuration)
            }
            if(this.filterServiceDelivery) {
                filtered = filtered.filter(item => item.psfServiceDelivery === this.filterServiceDelivery)
            }
            if(this.filterRemoteType) {
                filtered = filtered.filter(item => item.psfRemoteType === this.filterRemoteType)
            }
            if(this.filterServiceType) {
                filtered = filtered.filter(item => item.psfServiceType && item.psfServiceType.includes(this.filterServiceType))
            }
            if(this.filterFurtherActions) {
                filtered = filtered.filter(item => item.psfFurtherActions && item.psfFurtherActions.includes(this.filterFurtherActions))
            }

            // Count results
            this.totalSessionForms = filtered.length

            filtered.forEach(item => {
                this.countField(item.psfDuration, 'Duration')
                this.countField(item.psfServiceDelivery, 'Service Delivery')
                this.countField(item.psfRemoteType, 'Remote Type')
                this.countArray(item.psfServiceType, 'Service Type')
                this.countArray(item.psfFurtherActions, 'Further Actions')
            })

            // Prepare CSV export
            this.jsonData = filtered.map(item => ({
                clientID: item.clientID || '',
                sessionDate: item.psfDate || '',
                duration: item.psfDuration || '',
                serviceDelivery: item.psfServiceDelivery || '',
                remoteType: item.psfRemoteType || '',
                serviceType: Array.isArray(item.psfServiceType) ? item.psfServiceType.join(', ') : '',
                furtherActions: Array.isArray(item.psfFurtherActions) ? item.psfFurtherActions.join(', ') : '',
                signature: item.psfSignature || ''
            }))

            this.readyToExport = true
            this.isBusy = false
        },
        countField(value, type) {
            if(!value) return
            const filter = this.arrayResults.filter(ele => ele.text === value && ele.type === type)
            if(filter.length) {
                filter[0].count += 1
            }
        },
        countArray(values, type) {
            if(!values || !Array.isArray(values)) return
            values.forEach(value => {
                const filter = this.arrayResults.filter(ele => ele.text === value && ele.type === type)
                if(filter.length) {
                    filter[0].count += 1
                }
            })
        },
        preloadArrayResults() {
            // Limpiar array
            this.arrayResults = []

            // Precargar todas las opciones con count: 0
            this.psfDurationOptions.forEach(opt => {
                this.arrayResults.push({text: opt, type: 'Duration', count: 0})
            })
            this.psfServiceDeliveryOptions.forEach(opt => {
                this.arrayResults.push({text: opt, type: 'Service Delivery', count: 0})
            })
            this.psfRemoteTypeOptions.forEach(opt => {
                this.arrayResults.push({text: opt, type: 'Remote Type', count: 0})
            })
            this.psfServiceTypeOptions.forEach(opt => {
                this.arrayResults.push({text: opt, type: 'Service Type', count: 0})
            })
            this.psfFurtherActionsOptions.forEach(opt => {
                this.arrayResults.push({text: opt, type: 'Further Actions', count: 0})
            })

            // console.log('Array Results precargado:', this.arrayResults.length, 'items')
        }
    },
    created() {
        var user = auth.currentUser
        db.collection('usuarios').doc(user.uid).get()
        .then(doc => {
            this.isDataSpecialist = false
            if(doc.data().role === 'staff') {
                if(doc.data().permissions.includes('data specialist')) {
                    this.isDataSpecialist = true
                }
            } else if(doc.data().role === 'admin') {
                this.isDataSpecialist = true
            }
        })

        // Precargar arrayResults
        this.preloadArrayResults()

        // Load data from API
        // setTimeout(() => {
            this.$http.get('https://us-central1-nycpg-67e48.cloudfunctions.net/app/api/prod/peer-session-reports')
            .then(res => {
                this.filteredData = res.data
                this.applyFilters()
            })
        // }, 2500)
    }
}
</script>

<style>
.mx-input {
    height: 37px !important;
}
.form-control {
    background: #fff !important;
    background-color: #fff !important;
}
.range-date {
    padding: 8px;
    margin-top: 27px;
}
.vs__dropdown-option {
  white-space: normal !important;
}
.vs__dropdown-toggle {
  max-height: 38px;
}
.vs__selected-options {
  overflow: auto;
}
.vs__selected-options {
    overflow-x: hidden;
    overflow-y: hidden;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>